import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'

const Ad = () => {
  const initialized = useSelector((state) => state.auth.initialized)
  const isPatron = useSelector((state) => state.firebase.profile.patreon?.patron_status === 'active_patron')

  if (!initialized || isPatron) {
    return null
  }

  return (
    <Helmet>
      <script
        type='text/javascript'
        async='async'
        data-noptimize='1'
        data-cfasync='false'
        src='//scripts.mediavine.com/tags/edhrec.js'
      ></script>
    </Helmet>
  )
}

export default Ad
